import {Galleria} from 'primereact/galleria';
import {FC, memo, useCallback} from 'react';

import {Button} from 'primereact/button';
import {useNavigate} from 'react-router-dom';
import aluminyumAvif from '../assets/images/aluminyum-banner.avif';
import aluminyumPng from '../assets/images/aluminyum-banner.png';
import aluminyumWebp from '../assets/images/aluminyum-banner.webp';
import bakirAvif from '../assets/images/bakir-banner.avif';
import bakirPng from '../assets/images/bakir-banner.png';
import bakirWebp from '../assets/images/bakir-banner.webp';
import bronzAvif from '../assets/images/bronz-banner.avif';
import bronzPng from '../assets/images/bronz-banner.png';
import bronzWebp from '../assets/images/bronz-banner.webp';
import pirincAvif from '../assets/images/pirinc-banner.avif';
import pirincPng from '../assets/images/pirinc-banner.png';
import pirincWebp from '../assets/images/pirinc-banner.webp';
import {useAppSelector, useTranslation} from '../hooks';
import {languageState} from '../redux/slices/app';
import './homegallery.css';

interface ImageItem {
  key: number;
  imageSrc: string;
  srcWebp: string;
  srcAvif: string;
  alt: string;
  title: string;
}

const HomeGallery = () => {
  const {t} = useTranslation();

  const images: ImageItem[] = [
    {
      key: 1,
      imageSrc: bakirPng,
      srcWebp: bakirWebp,
      srcAvif: bakirAvif,
      alt: t('homeGalleryTitle1'),
      title: t('homeGalleryTitle1'),
    },
    {
      key: 2,
      imageSrc: pirincPng,
      srcWebp: pirincWebp,
      srcAvif: pirincAvif,
      alt: t('homeGalleryTitle2'),
      title: t('homeGalleryTitle2'),
    },
    {
      key: 3,
      imageSrc: aluminyumPng,
      srcWebp: aluminyumWebp,
      srcAvif: aluminyumAvif,
      alt: t('homeGalleryTitle3'),
      title: t('homeGalleryTitle3'),
    },
    {
      key: 4,
      imageSrc: bronzPng,
      srcWebp: bronzWebp,
      srcAvif: bronzAvif,
      alt: t('homeGalleryTitle4'),
      title: t('homeGalleryTitle4'),
    },
  ];

  const itemTemplate = (item: ImageItem) => {
    return (
      <div className="w-full">
        <picture>
          <source srcSet={item.srcAvif} type="image/avif" />
          <source srcSet={item.srcWebp} type="image/webp" />
          <img
            src={item.imageSrc}
            alt={item.title}
            aria-label={item.title}
            style={{
              width: '100%',
              height: '50vh',
              display: 'block',
              objectFit: 'cover',
              filter: 'brightness(0.7)',
            }}
          />
        </picture>
      </div>
    );
  };

  return (
    <Galleria
      value={images}
      autoPlay
      circular
      transitionInterval={2000}
      caption={({title}) => <GalleriaCaption title={title} />}
      changeItemOnIndicatorHover
      showThumbnails={false}
      showIndicators
      style={{backgroundColor: 'var(--hero-slider-background)'}}
      item={itemTemplate}
    />
  );
};

export default memo(HomeGallery);

interface GalleriaCaptionProps {
  title: string;
}

const GalleriaCaption: FC<GalleriaCaptionProps> = ({title}) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const selectedLanguage = useAppSelector(languageState);

  const onClick = useCallback(
    () => navigate('/' + selectedLanguage + t('pathMenuContact')),
    [navigate, selectedLanguage, t],
  );
  return (
    <div className="flex align-items-center justify-content-between gap-3">
      <p className="text-xl">{title}</p>
      <Button
        label={t('quoteButton')}
        severity="danger"
        raised
        onClick={onClick}
        aria-label={t('quoteButton')}
      />
    </div>
  );
};
